var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{class:[_vm.$style.container]},[_c('div',{class:_vm.$style.content,domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('div',{class:_vm.$style.footer},[_c('button',{class:_vm.$style.moreBtn,on:{"click":_vm.onViewMore}},[_vm._v("查看全部"),_c('i',{staticClass:"el-icon-arrow-right"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }